import React, { Children, lazy } from 'react';
import { motion } from 'framer-motion';
import { useInView } from '../hooks/useInView';
import { Crown, Sparkles } from 'lucide-react';
const bonos = [{
  title: 'Archivo Maestro 1: Mapa de Flujo 888',
  image: 'https://cdn.shopify.com/s/files/1/0981/0781/8286/files/BONO_1_-_Mapa_de_Flujo_888.png?v=1778374268',
  desc: 'Mapa claro para alinear tu enfoque y dirección hacia nuevas oportunidades.',
  exclusive: false
}, {
  title: 'Archivo Maestro 2: La Llave Maestra de la Claridad Interior',
  image: 'https://cdn.shopify.com/s/files/1/0981/0781/8286/files/BONO_2_-_LA_LLAVE_MAESTRA_DE_LA_ENERGIA_INTERNA.png?v=1778374268',
  desc: 'Claves prácticas para transformar tu relación con tus decisiones, hábitos y oportunidades.',
  exclusive: false
}, {
  title: 'Archivo Maestro 3: Protocolo de Claridad y Presencia',
  image: 'https://cdn.shopify.com/s/files/1/0981/0781/8286/files/BONO_3_-_protocolo_de_claridad_y_presencia.png?v=1780508361',
  desc: 'Protocolo simple para crear hábitos mentales más enfocados y conscientes.',
  exclusive: false
}, {
  title: 'Archivo Maestro 4: El Código de Expansión Interior',
  image: 'https://cdn.shopify.com/s/files/1/0981/0781/8286/files/BONO_4_-_El_codigo_de_expansion_interior.png?v=1780509236',
  desc: 'Material estructurado para tomar decisiones con mayor claridad y confianza interior.',
  exclusive: false
}, {
  title: 'Archivo Maestro Exclusivo: Arquitectura Interna de Decisiones 888',
  image: 'https://cdn.shopify.com/s/files/1/0981/0781/8286/files/BONO_Especial_-_Arquitectura_Interna_de_Decisiones_888.png?v=1778374268',
  desc: 'Ordena tu mente y toma decisiones con claridad, enfoque y serenidad.',
  exclusive: true
}, {
  title: 'Archivo Maestro Exclusivo: Protocolo de Integración y Reconexión 888',
  image: 'https://cdn.shopify.com/s/files/1/0981/0781/8286/files/BONO_Especial_-_Protocolo_de_Integracion_y_Expansion_888.png?v=1778374269',
  desc: 'Integra tu proceso interno y sostén una nueva forma de pensar y sentir.',
  exclusive: true
}];
export function QueIncluyeSection() {
  const [ref, isInView] = useInView({
    threshold: 0.1
  });
  const containerVariants = {
    hidden: {
      opacity: 0
    },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.15
      }
    }
  };
  const itemVariants = {
    hidden: {
      opacity: 0,
      y: 20
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.6,
        ease: 'easeOut'
      }
    }
  };
  return <section id="acceso-completo" className="py-16 sm:py-24 relative bg-[#050505] text-white overflow-hidden border-t border-white/5 scroll-mt-[56px] sm:scroll-mt-[70px]" data-id="element-663">
      {/* Premium Background Gradient */}
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_center,#0B0B0B_0%,#050505_100%)] pointer-events-none" data-id="element-664" />

      {/* Subtle Gold Glow */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full max-w-4xl h-[500px] bg-[radial-gradient(ellipse_at_top,rgba(212,175,55,0.08),transparent_70%)] pointer-events-none" data-id="element-665" />

      <div className="max-w-6xl mx-auto px-4 sm:px-6 relative z-10" data-id="element-666">
        <motion.div ref={ref} initial={{
        opacity: 0,
        y: 30
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {
        opacity: 0,
        y: 30
      }} transition={{
        duration: 0.8
      }} className="text-center mb-12 sm:mb-16" data-id="element-667">
          {/* Section Label */}
          <span className="inline-block text-[#D4AF37] sm:text-sm font-bold tracking-[3px] uppercase mb-4 text-[14px]" data-id="element-668">
            EXPERIENCIA COMPLETA
          </span>

          {/* Main Collection Mockup */}
          <div className="relative w-full max-w-3xl mx-auto mb-10 sm:mb-14 will-change-transform" data-id="element-669">
            <div className="absolute inset-0 bg-[radial-gradient(circle,rgba(212,175,55,0.15),transparent_60%)] blur-2xl pointer-events-none" data-id="element-670" />
            <img src="https://cdn.shopify.com/s/files/1/0981/0781/8286/files/mookup.png?v=1778383528" alt="Colección Completa Código 888" width="800" height="600" sizes="(max-width: 768px) 100vw, 800px" className="w-full h-auto object-contain relative z-10 drop-shadow-[0_20px_40px_rgba(0,0,0,0.8)] rounded-xl transform-gpu backface-hidden" loading="lazy" style={{
            contentVisibility: 'visible',
            containIntrinsicSize: 'auto 800px 600px'
          }} data-id="element-671" />
          </div>

          {/* Headline */}
          <h2 className="font-serif text-2xl sm:text-3xl md:text-4xl font-black leading-tight mb-6 drop-shadow-[0_0_15px_rgba(212,175,55,0.2)]" data-id="element-672">
            Todo lo que recibes al entrar
          </h2>

          {/* Subheadline */}
          <p className="text-[#BFBFBF] text-base sm:text-lg max-w-2xl mx-auto font-medium leading-relaxed" data-id="element-673">
            No es solo una guía. Es una biblioteca privada diseñada para
            acompañarte en tu proceso de claridad, enfoque y presencia interior.
          </p>
        </motion.div>

        {/* Bonus Grid */}
        <motion.div variants={containerVariants} initial="hidden" animate={isInView ? 'visible' : 'hidden'} className="grid grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-6 lg:gap-8 mb-16" data-id="element-674">
          {bonos.map((bono, idx) => <motion.div key={idx} variants={itemVariants} className="group relative bg-[#0B0B0B] border border-white/5 rounded-2xl overflow-hidden transition-all duration-300 hover:border-[#E6C55A]/50 hover:shadow-[0_0_30px_rgba(212,175,55,0.15)] hover:-translate-y-1 flex flex-col" data-id="element-675">
              {/* Subtle inner glow */}
              <div className="absolute inset-0 bg-gradient-to-b from-white/5 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 pointer-events-none" data-id="element-676" />

              {/* Image Container */}
              <div className="relative aspect-square w-full bg-[#050505] p-4 sm:p-6 flex items-center justify-center border-b border-white/5" data-id="element-677">
                <div className="absolute inset-0 bg-[radial-gradient(circle,rgba(212,175,55,0.1),transparent_70%)] opacity-0 group-hover:opacity-100 transition-opacity duration-500" data-id="element-678" />
                <img src={bono.image} alt={bono.title} width="400" height="400" sizes="(max-width: 640px) 50vw, (max-width: 1024px) 33vw, 400px" className="w-full h-full object-contain relative z-10 drop-shadow-2xl group-hover:scale-105 transition-transform duration-500" loading="lazy" data-id="element-679" />
              </div>

              {/* Content */}
              <div className="p-4 sm:p-6 flex-1 flex flex-col" data-id="element-680">
                <div className="flex items-start justify-between gap-2 mb-2" data-id="element-681">
                  <h3 className="font-bold text-sm sm:text-base leading-snug hidden sm:block text-[#D4AF37]" data-id="element-682">
                    {bono.title}
                  </h3>
                  <span className="shrink-0 bg-emerald-500/20 text-emerald-400 text-[10px] sm:text-xs font-black uppercase tracking-wider px-2 py-0.5 rounded-md border border-emerald-500/30" data-id="element-683">
                    GRATIS
                  </span>
                </div>
                <p className="text-[#8A8A8A] text-xs sm:text-sm leading-relaxed mt-auto" data-id="element-684">
                  {bono.desc}
                </p>
              </div>
            </motion.div>)}
        </motion.div>
      </div>
    </section>;
}